import Vue from 'vue/dist/vue.esm'
import TurbolinksAdapter from 'vue-turbolinks'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


export default function setup() {
  Vue.use(TurbolinksAdapter)

  Vue.component('fa-icon', FontAwesomeIcon)
}